function requireAll(r) {
  r.keys().forEach(r);
}

const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
const heroSection = pageWrapper.querySelector('.hero-section');

const state = {
  scrollY: 0,
  windowHeight: window.innerHeight,
  pageHeight: pageWrapper.offsetHeight
};

const updateVH = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const updatePageDimensions = () => {
  heroSection.style.width = `${pageWrapper.offsetWidth}px`;
  state.windowHeight = window.innerHeight;
  state.pageHeight = pageWrapper.offsetHeight;
};

const handleResize = () => {
  updateVH();
  updatePageDimensions();
  window.dispatchEvent(new Event('scroll'));
};

const switchImages = () => {
  const frames = document.querySelectorAll('.lp25-page-wrapper .frames');
  frames.forEach((frame, index) => {
    const images = frame.querySelectorAll('.frame');
    let currentIndex = 0;
    setInterval(() => {
      images[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % images.length;
    
      images[currentIndex].classList.add('active');
    }, 500);
  });
};

const textBarAnim = () => {
  const textBar = document.querySelector('.lp25-page-wrapper .text-bar__inner');
  let textBarX = 0;
  setInterval(() => {
    textBarX = (textBarX + 2) % 100;
    textBar.style.transform = `translateX(-${textBarX}%)`;
  }, 200);
};

const splitTextForAnimation = () => {
  const titles = document.querySelectorAll('.lp25-page-wrapper .page-title');
  titles.forEach(title => {
    const originalHTML = title.innerHTML;
    const placeholder = '%%BR%%';
    const tempHTML = originalHTML.replace(/<br\s*\/?>/gi, placeholder);
    const parts = tempHTML.split(/(%%BR%%)/);
    const wrappedHTML = parts.map(part => 
      part === '%%BR%%' ? '<br>' : [...part].map(char => `<span>${char}</span>`).join('')
    ).join('');
    title.innerHTML = wrappedHTML;
  });
};

const splitTextByWordForAnimation = () => {
  const titles = document.querySelectorAll('.lp25-page-wrapper .look__mini-title');

  titles.forEach(title => {
    const originalHTML = title.innerHTML;
    const BR = '%%BR%%';

    // <br> をプレースホルダに置換して分割
    const tempHTML = originalHTML.replace(/<br\s*\/?>/gi, BR);
    const parts = tempHTML.split(/(%%BR%%)/);

    const wrappedHTML = parts.map(part => {
      if (part === BR) return '<br>';
      // 単語＋区切り（空白や&nbsp;）を保持して分割
      const tokens = part.split(/(\s+|&nbsp;)/);

      return tokens.map(token => {
        // 空白（含：改行/タブ）や &nbsp; はそのまま出力してレイアウト保持
        if (token === '&nbsp;' || /^\s+$/.test(token)) return token;
        if (token === '') return '';
        // 単語を <span> でラップ
        return `<span>${token}</span>`;
      }).join('');
    }).join('');

    title.innerHTML = wrappedHTML;
  });
};


const typeWriter = element => {
  const letters = element.querySelectorAll('span');
  letters.forEach((letter, index) => {
    setTimeout(() => {
      letter.classList.add('active');
    }, index * 200);
  });
};

const timer = (func, delay) => setTimeout(func, delay);

const init = () => {
  pageWrapper.classList.remove('loaded');
  timer(() => pageWrapper.classList.add('loaded'), 1100);

  switchImages();
  textBarAnim();
  window.dispatchEvent(new Event('scroll'));

  typeTitles();
  setInterval(typeTitles, 8000);

};

const typeTitles = () => {

  const titles = document.querySelectorAll('.lp25-page-wrapper .page-title');

  titles.forEach((title, index) => {
    const letters = title.querySelectorAll('span');
    letters.forEach((letter, letterIndex) => {
      letter.classList.remove('active');
    });
  });

  timer(() => {
    titles.forEach((title, index) => {
      title.classList.add('activated');
      const letters = title.querySelectorAll('span');
      letters.forEach((letter, letterIndex) => {
        setTimeout(() => {
          letter.classList.add('active');
        }, (letterIndex * 200));
      });
    });    
  }, 1000);

};


const handleScroll = () => {
  state.scrollY = window.scrollY;
  heroSection.style.transform = `translateY(${state.scrollY * 0.5}px)`;

  document.querySelectorAll('.lp25-page-wrapper .look-section').forEach(section => {
    section.classList.toggle('inview', section.getBoundingClientRect().top <= 0);
  });

  document.querySelectorAll('.lp25-page-wrapper .look__title, .lp25-page-wrapper .look__mini-title').forEach(title => {
    const titleY = title.getBoundingClientRect().top;
    //console.log(titleY)
    if ((!title.classList.contains('executed') || title.querySelectorAll('.active').length == 0) && titleY <= state.windowHeight * 0.5) {
      title.classList.add('executed');
      typeWriter(title);
    }
  });

  const scrollBottom = state.scrollY + state.windowHeight;
  const gap = Math.min(0, state.pageHeight - scrollBottom);

  document.querySelectorAll('.lp25-page-wrapper .col:first-child').forEach(item => {
    item.style.transform = state.pageHeight <= scrollBottom ? `translateY(${gap}px)` : 'translateY(0)';
  });
};

window.addEventListener('load', () => {
  splitTextForAnimation();
  splitTextByWordForAnimation();
  handleResize();
  handleScroll();
  init();  
});

window.addEventListener('resize', handleResize);
window.addEventListener('scroll', handleScroll);
